<template lang="pug">
  div
    b-container#price-board
      b-row
        b-col
          show-price(v-model="value")
</template>

<script>
import ShowPrice from "@/components/firstOrder/ShowPrice";

export default {
  name: "PriceBoard",
  components: {
    ShowPrice,
  },
  props: {
    value: { type: Object, required: false }
  },
}
</script>

<style scoped>
#price-board {
  position: sticky;
  width: 210px;
  top: 0;
}
</style>